import Swiper from 'swiper';

export default function initAnchorSingle(): void {
    const $anchorSingle = document.querySelectorAll<HTMLElement>('.js-anchor-nav-slider');

    $anchorSingle.forEach($container => {
        new AnchorSingle($container);
    });
}

class AnchorSingle {
    $el: HTMLElement | null | undefined;
    swiper: Swiper | null = null;
    mdBreakpoint: number;

    constructor($el: HTMLElement | null) {
        this.$el = $el;
        this.mdBreakpoint = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-md'));

        if (this.$el) {
            window.addEventListener('resize', this.onWindowResize.bind(this));
            this.onWindowResize();
            this.initActiveAnchorElementsOnScroll();
            this.initAnchorClickOffset(); // 👈 Ajouté ici
        }
    }

    onWindowResize(): void {
        if (this.swiper && window.innerWidth > this.mdBreakpoint) {
            this.destroySwiper();
        } else if (!this.swiper && window.innerWidth <= this.mdBreakpoint) {
            this.createSwiper();
        }
    }

    createSwiper(): void {
        if (this.$el) {
            this.swiper = new Swiper(this.$el, {
                slidesPerView: 'auto',
                spaceBetween: 5,
                slidesOffsetAfter: 12,
            });
        }
    }

    destroySwiper(): void {
        this.swiper?.destroy(true, true);
        this.swiper = null;
    }

    /**
     * Met à jour les liens d’ancre actifs en fonction du scroll
     */
    initActiveAnchorElementsOnScroll(): void {
        window.addEventListener('scroll', () => {
            const windowTop = window.pageYOffset;
            const offset = ((document.querySelector('.anchor-single') as HTMLElement)?.offsetHeight || 0) + 100;

            const $anchorLinks = this.$el?.querySelectorAll<HTMLAnchorElement>('.anchor-link');
            const $anchorTargets = document.querySelectorAll<HTMLElement>('.js-anchor-target');

            $anchorTargets.forEach(target => {
                const rect = target.getBoundingClientRect();
                const elTopOffset = rect.top + windowTop - offset;
                const elBottomOffset = rect.bottom + windowTop - offset;

                if (windowTop >= elTopOffset && windowTop < elBottomOffset) {
                    $anchorLinks?.forEach(link => {
                        link.classList.remove('active');
                        if (link.hash.slice(1) === target.id) {
                            link.classList.add('active');
                        }
                    });
                }
            });
        }, false);
    }

    /**
     * Gère le scroll avec un décalage pour compenser l'ancre sticky
     */
    initAnchorClickOffset(): void {
        const $anchorLinks = this.$el?.querySelectorAll<HTMLAnchorElement>('.anchor-link');

        if (!$anchorLinks || $anchorLinks.length === 0) return;

        // Ajoute "active" au premier lien
        $anchorLinks[0].classList.add('active');

        $anchorLinks.forEach(link => {
            link.addEventListener('click', (e: MouseEvent) => {
                e.preventDefault();

                $anchorLinks.forEach(l => l.classList.remove('active'));
                link.classList.add('active');

                const targetId = link.getAttribute('href')?.substring(1);
                const targetElement = document.getElementById(targetId ?? '');

                if (targetElement) {
                    const offset = ((document.querySelector('.anchor-single') as HTMLElement)?.offsetHeight || 0) + 100;
                    const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
                    const offsetPosition = elementPosition - offset;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth',
                    });
                }
            });
        });
    }

}
